// 日期格式化工具函数
export function formatDate(dateString) {
  if (!dateString) return { month: '', day: '' }
  
  const date = new Date(dateString)
  
  // 月份英文简写数组
  const months = [
    'JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN',
    'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'
  ]
  
  return {
    month: months[date.getMonth()],
    day: date.getDate().toString().padStart(2, '0')
  }
}

/**
 * 判断素材类型是图片还是视频
 * @param {string} url - 素材的URL或文件名
 * @returns {string} - 返回 'image' 或 'video'
 */
export function getMediaType(url) {
  if (!url) return 'image' // 默认返回图片类型
  
  // 视频格式后缀数组
  const videoExtensions = [
    'mp4', 'webm', 'ogg', 'mov', 
    'avi', 'wmv', 'flv', 'm4v', 
    'mkv', '3gp'
  ]
  
  // 图片格式后缀数组
  const imageExtensions = [
    'jpg', 'jpeg', 'png', 'gif', 
    'bmp', 'webp', 'svg', 'tiff', 
    'ico'
  ]
  
  // 获取文件扩展名
  const extension = url.split('.').pop().toLowerCase()
  
  // 判断类型
  if (videoExtensions.includes(extension)) {
    return 'video'
  } else if (imageExtensions.includes(extension)) {
    return 'image'
  }
  
  // 如果无法判断，默认返回图片类型
  return 'image'
}